import { useContext, useEffect, useState } from "react";

import "../../../styles/dashboard/settings/settingsBusinessInfoIndex.css";
import SettingsIndex from "./SettingsIndex";
import { colorToRgba, getFirstCharacters } from "../../../utils/helpers";
import { getBusinessInfo } from "../../../redux/insight";
import { useDispatch, useSelector } from "react-redux";
import RootState from "../../../redux/types";
import ActionContext from "../../../context/ActionContext";
import Skeleton from "react-loading-skeleton";
import { useDarkMode } from "../../../utils/themes/useDarkMode";

const SettingsBusinessInformationIndex = () => {
  const [editMode, seteditMode] = useState(false);
  const [businessInfo, setBusinessInfo] = useState({
    firstName: "Abigail",
    lastName: "Uye",
    address: "20 The Quad Layi Yusuf Lekki Lagos",
    businessName: "Regius portus",
    emmailAddress: "abby@gmail.com",
    phoneNumber: "09078654433",
    businessIndustry: "Beauty",
    employeeCount: "50-100",
    accountNumber: "2348588865",
    bankName: "Gtb",
    rcNumber: "102345",
    monthlyTransactionRate: "50,000 000",
    feeCategory: "Top Business Fee",
    region: "Nigeria",
    businessDiscription:
      "Deals in importing and exporting luxurious wears and shoes",
  });
  const { loading_alert, business_info } = useSelector(
    (state: RootState) => state.insights
  );
  const actionCtx = useContext(ActionContext);
  const [theme, toggle] = useDarkMode(localStorage.getItem("theme"));
  const dispatch = useDispatch();
  const handleBusinessInfoChange = (
    field: keyof typeof businessInfo,
    value: string
  ) => {
    setBusinessInfo((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleFetchBusinessInfo = async () => {
    const obj = {
      name: "",
    };
    const data = await dispatch(getBusinessInfo(obj) as any);

    if (data?.payload?.status === "success") {
      // console.log("fetching business info", data);
    }
  };
  useEffect(() => {
    if (Object.keys(business_info).length === 0) {
      handleFetchBusinessInfo();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actionCtx?.configDetails, businessInfo]);

  return (
    <SettingsIndex>
      <div className="business_info_settings-right-side-wrap-cont-inner">
        <div className="heading-container-carrier">
          {loading_alert ? (
            <Skeleton
              // variant="circular"
              width={30}
              height={30}
              style={{
                marginBottom: ".3rem",
                borderRadius: "50%",
              }}
            />
          ) : (
            <div className="abreviation-text-holder  grey-bg">
              <p
                className="the-abrev-text"
                style={{
                  color:
                    theme === "light"
                      ? colorToRgba("var(--primary-base-color)", 0.9)
                      : "#ffffff",
                }}
              >
                {getFirstCharacters(
                  business_info?.business_name
                    ? business_info.business_name
                    : "NA"
                )}
              </p>
            </div>
          )}
          <div className="name-and-email-heading-box">
            {loading_alert ? (
              <Skeleton
                width={200}
                height={20}
                style={{ marginBottom: ".3rem" }}
              />
            ) : (
              <p className="name-and-email-heading-name">
                {business_info?.business_name
                  ? business_info?.business_name
                  : "-----"}
              </p>
            )}
            {loading_alert ? (
              <Skeleton
                width={200}
                height={20}
                style={{ marginBottom: ".3rem" }}
              />
            ) : (
              <p className="name-and-email-heading-email">
                {business_info?.email ? business_info?.email : "-----"}
              </p>
            )}
          </div>
        </div>

        <div className="settings-right-side-wrap-cont-input-box">
          <div className="settings-right-side-wrap-cont-input-fields">
            {loading_alert ? (
              <Skeleton
                width={200}
                height={20}
                style={{ marginBottom: ".3rem" }}
              />
            ) : (
              <div className="business-details-wrap-box-cont">
                <p className="business-details-header-wrap-box">
                  Business name
                </p>
                <p className="business-details-body-wrap-box">
                  {business_info?.business_name
                    ? business_info?.business_name
                    : "-----"}
                </p>
              </div>
            )}
            {loading_alert ? (
              <Skeleton
                width={200}
                height={20}
                style={{ marginBottom: ".3rem" }}
              />
            ) : (
              <div className="business-details-wrap-box-cont">
                <p className="business-details-header-wrap-box">
                  Business Address
                </p>
                <p className="business-details-body-wrap-box">
                  {business_info?.address ? business_info?.address : "-----"}
                </p>
              </div>
            )}
          </div>

          <div className="settings-right-side-wrap-cont-input-fields">
            {loading_alert ? (
              <Skeleton
                width={200}
                height={20}
                style={{ marginBottom: ".3rem" }}
              />
            ) : (
              <div className="business-details-wrap-box-cont">
                <p className="business-details-header-wrap-box">Region</p>
                <p className="business-details-body-wrap-box">
                  {business_info?.region ? business_info?.region : "-----"}
                </p>
              </div>
            )}
            {loading_alert ? (
              <Skeleton
                width={200}
                height={20}
                style={{ marginBottom: ".3rem" }}
              />
            ) : (
              <div className="business-details-wrap-box-cont">
                <p className="business-details-header-wrap-box">
                  Business Rc Number
                </p>
                <p className="business-details-body-wrap-box">
                  {business_info.rc_number ? business_info.rc_number : "-----"}
                </p>
              </div>
            )}
          </div>

          <div className="settings-right-side-wrap-cont-input-fields">
            {loading_alert ? (
              <Skeleton
                width={200}
                height={20}
                style={{ marginBottom: ".3rem" }}
              />
            ) : (
              <div className="business-details-wrap-box-cont">
                <p className="business-details-header-wrap-box">
                  Business Industry
                </p>
                <p className="business-details-body-wrap-box">
                  {business_info?.business_category
                    ? business_info.business_category
                    : "-----"}
                </p>
              </div>
            )}
            {loading_alert ? (
              <Skeleton
                width={200}
                height={20}
                style={{ marginBottom: ".3rem" }}
              />
            ) : (
              <div className="business-details-wrap-box-cont">
                <p className="business-details-header-wrap-box">Fee Category</p>
                <p className="business-details-body-wrap-box">
                  {business_info?.fee_category
                    ? business_info.fee_category
                    : "-----"}
                </p>
              </div>
            )}
          </div>

          <div className="settings-right-side-wrap-cont-input-fields">
            {loading_alert ? (
              <Skeleton
                width={200}
                height={20}
                style={{ marginBottom: ".3rem" }}
              />
            ) : (
              <div className="business-details-wrap-box-cont">
                <p className="business-details-header-wrap-box">
                  Business Description
                </p>
                <p className="business-details-body-wrap-box">
                  {business_info?.description
                    ? business_info.description
                    : "-----"}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </SettingsIndex>
  );
};

export default SettingsBusinessInformationIndex;
